import { Component } from '@angular/core';
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-access-denied',
  imports: [
    I18NextPipe
  ],
  templateUrl: './access-denied.component.html',
})
export class AccessDeniedComponent {}
